import React from 'react';
import { useLanguage } from './LanguageContext';
export function LanguageSwitcher() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="flex items-center gap-2 text-[10px] tracking-[2px] font-medium" data-id="element-163">
      <button onClick={() => setLang('en')} className={`transition-colors duration-300 ${lang === 'en' ? 'text-white' : 'text-[#f5f5f5]/40 hover:text-[#f5f5f5]/70'}`} data-id="element-164">
        EN
      </button>
      <span className="text-[#f5f5f5]/20" data-id="element-165">|</span>
      <button onClick={() => setLang('es')} className={`transition-colors duration-300 ${lang === 'es' ? 'text-white' : 'text-[#f5f5f5]/40 hover:text-[#f5f5f5]/70'}`} data-id="element-166">
        ES
      </button>
    </div>;
}